import { render, staticRenderFns } from "./productsTrad.vue?vue&type=template&id=204f0ffe&"
import script from "./productsTrad.vue?vue&type=script&lang=js&"
export * from "./productsTrad.vue?vue&type=script&lang=js&"
import style0 from "./productsTrad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports